import gameIds from 'a/hub/data/GameIds';

// TODO: replace "NEW_GAME" with your gameId
export const GAME_ID = gameIds.STORYLAB;

export const GAME_MODES = {
  MODELING: 'MODELING',
  READING: 'READING',
  CLOZE: 'CLOZE',
  SUMMARY: 'SUMMARY',
};

export const LEVEL_COUNT = 18;

export const QUESTIONS_PER_SECTION = 3;

export const QUESTION_SECTIONS = [
  {
    mode: GAME_MODES.CLOZE,
    test: 0,
  },
  {
    mode: GAME_MODES.SUMMARY,
    test: 0,
  }, {
    mode: GAME_MODES.CLOZE,
    test: 1,
  },
  {
    mode: GAME_MODES.SUMMARY,
    test: 1,
  },
];

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
  ONBOARDING_VIEW: 'ONBOARDING_VIEW',
  ONBOARDING_INTRO: 'ONBOARDING_INTRO',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
  REPEAT_MAIN_ONBOARDING: 'REPEAT_MAIN_ONBOARDING',
  SCORECARD_VIEW: 'SCORECARD_VIEW',
  MODELING_VIEW: 'MODELING_VIEW',
  MODELING_INTRO_VIEW: 'MODELING_INTRO_VIEW',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  SELECT_RESPONSE: 'SELECT_RESPONSE',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  SET_LEVEL_INDEX: 'SET_LEVEL_INDEX',
  CHANGE_GAME_MODE: 'CHANGE_GAME_MODE',
  INCREMENT_TEST: 'INCREMENT_TEST',
  SELECT_ANSWER: 'SELECT_ANSWER',
  SET_LEVEL_CURRICULUM: 'SET_LEVEL_CURRICULUM',
  SET_FULL_CURRICULUM: 'SET_FULL_CURRICULUM',
  INCREMENT_QUESTION_INDEX: 'INCREMENT_QUESTION_INDEX',
  RESET_QUESTION_INDEX: 'RESET_QUESTION_INDEX',
  START_NEXT_TEST: 'START_NEXT_TEST',
  SET_AVERAGE_WPM: 'SET_AVERAGE_WPM',
  INIT_MODELING: 'INIT_MODELING',
  SELECT_UNFAMILIAR_WORD: 'SELECT_UNFAMILIAR_WORD',
  SET_INTERACTION_LOCKED: 'SET_INTERACTION_LOCKED',
  SET_AUDIO_PLAYED: 'SET_AUDIO_PLAYED',
  UNLOCK_LEVEL: 'UNLOCK_LEVEL',
  INCREMENT_PROGRESS: 'INCREMENT_PROGRESS',
  QUICK_PASS: 'QUICK_PASS',
  QUICK_FAIL: 'QUICK_FAIL',
  SET_QUESTION: 'SET_QUESTION',
  SET_SECONDS_ELAPSED: 'SET_SECONDS_ELAPSED',
};

export const WPM_KEYS = {
  SLOWEST: 'SLOWEST',
  SLOW: 'SLOW',
  TARGET: 'TARGET',
  MAX: 'MAX',
  STOP: 'STOP',
  DEBUG: 'DEBUG',
};

export const WPM = {
  [WPM_KEYS.SLOWEST]: 96,
  [WPM_KEYS.SLOW]: 111,
  [WPM_KEYS.TARGET]: 121,
  [WPM_KEYS.MAX]: 134,
  [WPM_KEYS.DEBUG]: 350,
};

export const READING_SPEEDS = {
  [WPM_KEYS.STOP]: {
    id: 'stop',
    indexId: -1,
    wpm: 0,
    pixelsPerMinute: 0,
  },
  [WPM_KEYS.SLOWEST]: {
    id: 'slowest',
    indexId: 1,
    wpm: 96,
    pixelsPerMinute: 870,
  },
  [WPM_KEYS.SLOW]: {
    id: 'slow',
    indexId: 2,
    wpm: 111,
    pixelsPerMinute: 1020,
  },
  [WPM_KEYS.TARGET]: {
    id: 'target',
    indexId: 3,
    wpm: 121,
    pixelsPerMinute: 1070,
  },
  [WPM_KEYS.MAX]: {
    indexId: 4,
    id: 'max',
    wpm: 134,
    pixelsPerMinute: 1170,
  },
};

export const PIXEL_HEIGHT_PER_MINUTE = {
  [WPM.STOP]: 0,
  [WPM.SLOWEST]: 870, // ie: takes 1 minute to cross 870 pixels of height, which roughly fits 96 words
  [WPM.SLOW]: 1020,
  [WPM.TARGET]: 1070,
  [WPM.MAX]: 1170,
  [WPM.DEBUG]: 2500,
};

export const READER_SIZE = {
  HEIGHT: 170,
  WIDTH: 876,
};

export const REPORTING = {
  MODELING: {
    START: 'START',
    RUN_TEST: 'RUN TEST',
  },
};

export const MASTERY_CRITERIA = {
  QUESTIONS: 2,
  SPEEDS: [WPM_KEYS.TARGET, WPM_KEYS.MAX, WPM_KEYS.DEBUG],
};

export const TEST_INDEXES = [0, 1];
